<div class="flex items-center gap-2 md:flex-wrap md:gap-3">
  <mat-button-toggle-group
    [formControl]="form.controls.completed"
    class="custom-toggle-group size-m"
    hideSingleSelectionIndicator
  >
    <mat-button-toggle [value]="false" class="flex-1">
      <dojo-icon [icon]="'circle-dashed'" class="mr-2" [size]="18" />
      <span class="font-medium">{{ 'examdojo.challenge_activity_question_status.todo' | transloco }}</span>
    </mat-button-toggle>
    <mat-button-toggle [value]="true" class="flex-1">
      <dojo-icon [icon]="'circle-check'" class="mr-2" [size]="18" [faPrefix]="'fas'" [iconClass]="'text-sky-500'" />
      <span class="font-medium">{{ 'examdojo.challenge_activity_question_status.done' | transloco }}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <dojo-multiple-filters-button
    *ifSmallLayout
    [buttonLabel]="'examdojo.question_bank.all_filters' | transloco"
    [titleLabel]="'examdojo.question_bank.all_filters' | transloco"
    (clearAll)="clearAllFilters()"
  >
    @if (state.availableFilters.type) {
      <ng-template dojoFilterSection="type" [label]="'examdojo.type' | transloco" [count]="state.filterCounts.type">
        <ng-container *ngTemplateOutlet="typeFilterContent" />
      </ng-template>
    }
    @if (state.availableFilters.difficulty) {
      <ng-template
        dojoFilterSection="difficulty"
        [label]="'examdojo.difficulty_label' | transloco"
        [count]="state.filterCounts.difficulty"
      >
        <ng-container *ngTemplateOutlet="difficultyFilterContent" />
      </ng-template>
    }
    @if (state.availableFilters.maxPoints) {
      <ng-template
        dojoFilterSection="maxMarks"
        [label]="'examdojo.max_marks' | transloco"
        [count]="state.filterCounts.maxMarks"
      >
        <ng-container *ngTemplateOutlet="marksFilterContent" />
      </ng-template>
    }
    @if (state.availableFilters.latestScore && form.controls.completed.value) {
      <ng-template
        dojoFilterSection="latestScore"
        [label]="'examdojo.latest_accuracy' | transloco"
        [count]="state.filterCounts.latestScore"
      >
        <ng-container *ngTemplateOutlet="latestScoreFilterContent" />
      </ng-template>
    }

    @if (state.availableFilters.lastAttempted && form.controls.completed.value) {
      <ng-template
        dojoFilterSection="lastAttempted"
        [label]="'examdojo.last_attempted' | transloco"
        [count]="state.filterCounts.lastAttempted"
      >
        <ng-container *ngTemplateOutlet="lastAttemptedFilterContent"></ng-container>
      </ng-template>
    }
    @if (state.availableFilters.tags) {
      <ng-template
        dojoFilterSection="tags"
        [label]="'examdojo.tags.tags_label' | transloco"
        [count]="state.filterCounts.tags"
      >
        <ng-container *ngTemplateOutlet="tagsFilterContent" />
      </ng-template>
    }
    <ng-template
      dojoFilterSection="topics"
      [label]="'examdojo.topics_tree.topics' | transloco"
      [count]="state.topicsCount"
    >
      <ng-container *ngTemplateOutlet="topicsFilterContent" />
    </ng-template>
  </dojo-multiple-filters-button>

  <dojo-filter-button
    *ifSmallLayout
    [defaultLabel]="'examdojo.topics_tree.topics' | transloco"
    [count]="state.topicsCount"
    [alwaysShowCount]="true"
    (clear)="clearTopics()"
  >
    <ng-template #filterContent>
      <ng-container *ngTemplateOutlet="topicsFilterContent" />
    </ng-template>
  </dojo-filter-button>

  <ng-container *ifSmallLayout>
    @if (state.availableFilters.difficulty) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.difficulty_label' | transloco"
        [selectedLabel]="state.selectedDifficultyLabel"
        [count]="state.filterCounts.difficulty"
        (clear)="resetFilters(['difficulties'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="difficultyFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.type) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.type' | transloco"
        [selectedLabel]="state.selectedTypeLabel"
        [count]="state.filterCounts.type"
        (clear)="resetFilters(['types'])"
        [customMatMenuClass]="'types-filter-menu filters-bank-mat-menu'"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="typeFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.maxPoints) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.max_marks' | transloco"
        [selectedLabel]="state.selectedMaxMarksLabel"
        [count]="state.filterCounts.maxMarks"
        [clearLabelKey]="'examdojo.reset'"
        (clear)="resetFilters(['minPoints', 'maxPoints'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="marksFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.tags) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.tags.tags_label' | transloco"
        [selectedLabel]="state.selectedTagLabel"
        [count]="state.filterCounts.tags"
        (clear)="resetFilters(['tags'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="tagsFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }
  </ng-container>

  <ng-container *ifWideLayout>
    @if (state.availableFilters.difficulty) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.difficulty_label' | transloco"
        [selectedLabel]="state.selectedDifficultyLabel"
        [count]="state.filterCounts.difficulty"
        (clear)="resetFilters(['difficulties'])"
        [customMatMenuClass]="'filters-bank-mat-menu'"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="difficultyFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.type) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.type' | transloco"
        [selectedLabel]="state.selectedTypeLabel"
        [count]="state.filterCounts.type"
        [customMatMenuClass]="'types-filter-menu filters-bank-mat-menu'"
        (clear)="resetFilters(['types'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="typeFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.maxPoints) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.max_marks' | transloco"
        [selectedLabel]="state.selectedMaxMarksLabel"
        [count]="state.filterCounts.maxMarks"
        [clearLabelKey]="'examdojo.reset'"
        (clear)="resetFilters(['minPoints', 'maxPoints'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="marksFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.tags) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.tags.tags_label' | transloco"
        [selectedLabel]="state.selectedTagLabel"
        [count]="state.filterCounts.tags"
        (clear)="resetFilters(['tags'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="tagsFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.latestScore && form.controls.completed.value) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.latest_accuracy' | transloco"
        [selectedLabel]="state.selectedLatestScoreLabel"
        [count]="state.filterCounts.latestScore"
        [clearLabelKey]="'examdojo.reset'"
        (clear)="resetFilters(['minLatestScore', 'maxLatestScore'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="latestScoreFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }

    @if (state.availableFilters.lastAttempted && form.controls.completed.value) {
      <dojo-filter-button
        [defaultLabel]="'examdojo.last_attempted' | transloco"
        [selectedLabel]="state.selectedLastAttemptedLabel"
        [count]="state.filterCounts.lastAttempted"
        (clear)="resetFilters(['lastAttemptDateFrom', 'lastAttemptDateTo'])"
      >
        <ng-template #filterContent>
          <ng-container *ngTemplateOutlet="lastAttemptedFilterContent" />
        </ng-template>
      </dojo-filter-button>
    }
  </ng-container>

  @if (state.hasActiveFilters) {
    <button type="button" class="text-secondary whitespace-nowrap text-sm font-medium" (click)="clearAllFilters()">
      {{ 'examdojo.clear_all' | transloco }}
    </button>
  }
</div>

<ng-template #difficultyFilterContent>
  <mat-selection-list
    [formControl]="form.controls.difficulties"
    class="custom-selection-list-checkbox-appearance bank-filters"
  >
    @for (option of state.difficultyOptions; track option.value) {
      <mat-list-option [togglePosition]="'before'" [value]="option.value">
        <span class="text-primary text-md md:text-sm">{{ option.label }}</span>
      </mat-list-option>
    }
  </mat-selection-list>
</ng-template>

<ng-template #typeFilterContent>
  <mat-selection-list
    [formControl]="form.controls.types"
    class="custom-selection-list-checkbox-appearance bank-filters"
  >
    @for (option of state.typeOptions; track option.value) {
      <mat-list-option [togglePosition]="'before'" [value]="option.value">
        <span class="text-primary text-md md:text-sm">{{ option.label }}</span>
      </mat-list-option>
    }
  </mat-selection-list>
</ng-template>

<ng-template #marksFilterContent>
  <div class="flex flex-col px-1.5 pt-8">
    <div class="flex items-end justify-center px-3 pb-2">
      <mat-slider
        discrete
        [min]="state.marksRange.min"
        [step]="1"
        [max]="state.marksRange.max"
        class="slider-always-show-tooltips w-full"
      >
        <input
          #minPointsSlider
          matSliderStartThumb
          [value]="form.controls.minPoints.value"
          (change)="form.controls.minPoints.setValue(+minPointsSlider.value)"
        />
        <input
          #maxPointsSlider
          matSliderEndThumb
          [value]="form.controls.maxPoints.value"
          (change)="form.controls.maxPoints.setValue(+maxPointsSlider.value)"
        />
      </mat-slider>
    </div>
  </div>
</ng-template>

<ng-template #latestScoreFilterContent>
  <div class="flex flex-col px-1.5 pt-8">
    <div class="flex items-end justify-center px-3 pb-2">
      <mat-slider
        discrete
        [min]="0"
        [step]="1"
        [max]="100"
        [displayWith]="formatPercentage"
        class="slider-always-show-tooltips w-full"
      >
        <input
          #minLatestScoreSlider
          matSliderStartThumb
          [value]="form.controls.minLatestScore.value"
          (change)="form.controls.minLatestScore.setValue(+minLatestScoreSlider.value)"
        />
        <input
          #maxLatestScoreSlider
          matSliderEndThumb
          [value]="form.controls.maxLatestScore.value"
          (change)="form.controls.maxLatestScore.setValue(+maxLatestScoreSlider.value)"
        />
      </mat-slider>
    </div>
  </div>
</ng-template>

<ng-template #topicsFilterContent>
  <dojo-question-bank-topics-explorer class="mobile-topics-explorer" />
</ng-template>

<ng-template #lastAttemptedFilterContent>
  <div class="flex flex-col gap-2 px-4">
    <div class="flex gap-2">
      <mat-form-field class="size-s date-field flex-1">
        <input
          matInput
          [value]="form.controls.lastAttemptDateFrom.value | date: 'shortDate'"
          [placeholder]="'examdojo.question_bank.date_from' | transloco"
          readonly
        />
        @if (form.controls.lastAttemptDateFrom.value) {
          <button
            matIconSuffix
            type="button"
            (click)="form.controls.lastAttemptDateFrom.reset(); $event.stopPropagation()"
          >
            <dojo-icon icon="circle-xmark" faPrefix="fas" class="text-secondary" />
          </button>
        }
      </mat-form-field>
      <mat-form-field class="size-s date-field flex-1">
        <input
          matInput
          [value]="form.controls.lastAttemptDateTo.value | date: 'shortDate'"
          [placeholder]="'examdojo.question_bank.date_to' | transloco"
          readonly
        />
        @if (form.controls.lastAttemptDateTo.value) {
          <button
            matIconSuffix
            type="button"
            (click)="form.controls.lastAttemptDateTo.reset(); $event.stopPropagation()"
          >
            <dojo-icon icon="circle-xmark" faPrefix="fas" class="text-secondary" />
          </button>
        }
      </mat-form-field>
    </div>
    <mat-calendar [selected]="state.selectedDateRange" (selectedChange)="onDateRangeChange($event)" [maxDate]="today" />
  </div>
</ng-template>

<ng-template #tagsFilterContent>
  <dojo-tag-selection-list
    [control]="form.controls.tags"
    [searchPlaceholder]="'examdojo.tags.search_placeholder' | transloco"
  />
</ng-template>
